import { render } from "./PdfViewer.vue?vue&type=template&id=68a1682e&scoped=true&ts=true"
import script from "./PdfViewer.vue?vue&type=script&lang=ts"
export * from "./PdfViewer.vue?vue&type=script&lang=ts"

import "./PdfViewer.vue?vue&type=style&index=0&id=68a1682e&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a1682e"]])

export default __exports__